(() => {
  window.Shopify = window.Shopify || {};
  window.Shopify.currency = { ...(window.Shopify.currency || {}), active: 'PKR' };

  const excludedTags = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'INPUT']);
  const normalizeCurrencyText = (text) => text
    .replace(/\bUS\$\s*/gi, 'PKR ')
    .replace(/\bUSD\b/gi, 'PKR')
    .replace(/\$(?=\s?\d)/g, 'PKR ');

  const cleanTextNodes = (root) => {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const textNodes = [];

    while (walker.nextNode()) textNodes.push(walker.currentNode);

    textNodes.forEach((node) => {
      const parent = node.parentElement;
      if (!parent || excludedTags.has(parent.tagName)) return;

      const updatedText = normalizeCurrencyText(node.nodeValue || '');
      if (updatedText !== node.nodeValue) node.nodeValue = updatedText;
    });
  };

  const startCurrencyGuard = () => {
    cleanTextNodes(document.body);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            const parent = node.parentElement;
            if (parent && !excludedTags.has(parent.tagName)) {
              node.nodeValue = normalizeCurrencyText(node.nodeValue || '');
            }
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            cleanTextNodes(node);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startCurrencyGuard, { once: true });
  } else {
    startCurrencyGuard();
  }
})();
